import axios from 'axios';
import { getUserData } from '../Dashboard/dashboardService';

const BASE_URL = 'https://lms.akiliapp.co.tz/api';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

/** Admin sees all on these lists; normal users must send user_id. */
const ADMIN_LIST_ALL_ENDPOINTS = ['/certificate/ilist', '/assignment/ilist'];

/** Always use auth token only — do not add user_id query param. */
const TOKEN_SCOPED_LIST_ENDPOINTS = ['/userModule/ilist', '/users/iget'];

apiClient.interceptors.request.use(
  (config) => {
    const userData = getUserData();
    const token = userData?.access_token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const url = config.url || '';
    const role = (userData?.role || '').toString().toLowerCase();
    const isAdmin = role === 'admin' || role === 'administrator';
    const skipUserFilter =
      TOKEN_SCOPED_LIST_ENDPOINTS.some((path) => url.includes(path)) ||
      (ADMIN_LIST_ALL_ENDPOINTS.some((path) => url.includes(path)) && isAdmin);
    if (userData?.id && !skipUserFilter) {
      config.params = { ...config.params, user_id: userData.id };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export { apiClient, BASE_URL };
export default apiClient;
